window.rangeSliderInterop = {
    initialize: function (sliderId, numberOfValues) {
        const container = document.getElementById(sliderId);
        if (!container) return;

        const minThumb = container.querySelector('.min-thumb');
        const maxThumb = container.querySelector('.max-thumb');
        const fillBar = container.querySelector('.slider-range-selected');

        if (!minThumb || !maxThumb || !fillBar) return;

        const updateFillBar = () => {
            const minVal = parseInt(minThumb.value);
            const maxVal = parseInt(maxThumb.value);
            
            // Calculate positions as percentages
            const rangeStart = (minVal / (numberOfValues - 1)) * 100;
            const rangeWidth = ((maxVal - minVal) / (numberOfValues - 1)) * 100;

            // Apply styles immediately
            fillBar.style.left = rangeStart + '%';
            fillBar.style.width = rangeWidth + '%';
        };

        // Update on input (while dragging)
        minThumb.addEventListener('input', updateFillBar);
        maxThumb.addEventListener('input', updateFillBar);

        // Store cleanup function
        container._rangeSliderCleanup = () => {
            minThumb.removeEventListener('input', updateFillBar);
            maxThumb.removeEventListener('input', updateFillBar);
        };
    },

    dispose: function (sliderId) {
        const container = document.getElementById(sliderId);
        if (container && container._rangeSliderCleanup) {
            container._rangeSliderCleanup();
            delete container._rangeSliderCleanup;
        }
    }
};
